// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function method(t) {
  return t.method;
}

function url(t) {
  return t.url;
}

function headers(t) {
  return t.headers;
}

function staticParams(t) {
  return t.staticParams;
}

function dynamicParams(t) {
  return t.dynamicParams;
}

function credentials(t) {
  return t.credentials;
}

function isActive(t) {
  return t.isActive;
}

function apiType(t) {
  return t.apiType;
}

function setId(t, id) {
  return {
          id: id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setMethod(t, method) {
  return {
          id: t.id,
          name: t.name,
          method: method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setUrl(t, url) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setHeaders(t, headers) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setStaticParams(t, staticParams) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setDynamicParams(t, dynamicParams) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setCredentials(t, credentials) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: credentials,
          isActive: t.isActive,
          apiType: t.apiType
        };
}

function setIsActive(t, isActive) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: isActive,
          apiType: t.apiType
        };
}

function setApiType(t, apiType) {
  return {
          id: t.id,
          name: t.name,
          method: t.method,
          url: t.url,
          headers: t.headers,
          staticParams: t.staticParams,
          dynamicParams: t.dynamicParams,
          credentials: t.credentials,
          isActive: t.isActive,
          apiType: apiType
        };
}

function empty(apiType) {
  return {
          id: undefined,
          name: "",
          method: "POST",
          url: "",
          headers: "{}",
          staticParams: "{}",
          dynamicParams: "{}",
          credentials: "{}",
          isActive: true,
          apiType: apiType
        };
}

function decodeJsonField(json) {
  try {
    return Json_decode.string(json);
  }
  catch (exn){
    try {
      return JSON.stringify(json);
    }
    catch (exn$1){
      return "{}";
    }
  }
}

function decodeApiType(json) {
  var match = Json_decode.field("api_type", Json_decode.string, json);
  switch (match) {
    case "whatsapp" :
        return "WhatsApp";
    default:
      return "SMS";
  }
}

function fromJson(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          method: Json_decode.field("method", Json_decode.string, json),
          url: Json_decode.field("url", Json_decode.string, json),
          headers: Json_decode.field("headers", decodeJsonField, json),
          staticParams: Json_decode.field("static_params", decodeJsonField, json),
          dynamicParams: Json_decode.field("dynamic_params", decodeJsonField, json),
          credentials: Json_decode.field("credentials", decodeJsonField, json),
          isActive: Json_decode.field("is_active", Json_decode.bool, json),
          apiType: decodeApiType(json)
        };
}

function encodeApiType(apiType) {
  if (apiType === "SMS") {
    return "sms";
  } else {
    return "whatsapp";
  }
}

function toJson(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "method",
                    t.method
                  ],
                  tl: {
                    hd: [
                      "url",
                      t.url
                    ],
                    tl: {
                      hd: [
                        "headers",
                        t.headers
                      ],
                      tl: {
                        hd: [
                          "static_params",
                          t.staticParams
                        ],
                        tl: {
                          hd: [
                            "dynamic_params",
                            t.dynamicParams
                          ],
                          tl: {
                            hd: [
                              "credentials",
                              t.credentials
                            ],
                            tl: {
                              hd: [
                                "is_active",
                                t.isActive
                              ],
                              tl: {
                                hd: [
                                  "api_type",
                                  encodeApiType(t.apiType)
                                ],
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function decode(json) {
  return Json_decode.field("api_configuration", fromJson, json);
}

function decodeList(json) {
  return Json_decode.field("api_configurations", (function (param) {
                return Json_decode.list(fromJson, param);
              }), json);
}

function statusText(t) {
  if (t.isActive) {
    return "Active";
  } else {
    return "Inactive";
  }
}

function statusClass(t) {
  if (t.isActive) {
    return "text-green-600";
  } else {
    return "text-red-600";
  }
}

var availableMethods = {
  hd: "GET",
  tl: {
    hd: "POST",
    tl: /* [] */0
  }
};

var availableApiType = {
  hd: "sms",
  tl: {
    hd: "whatsapp",
    tl: /* [] */0
  }
};

exports.id = id;
exports.name = name;
exports.method = method;
exports.url = url;
exports.headers = headers;
exports.staticParams = staticParams;
exports.dynamicParams = dynamicParams;
exports.credentials = credentials;
exports.isActive = isActive;
exports.apiType = apiType;
exports.setId = setId;
exports.setName = setName;
exports.setMethod = setMethod;
exports.setUrl = setUrl;
exports.setHeaders = setHeaders;
exports.setStaticParams = setStaticParams;
exports.setDynamicParams = setDynamicParams;
exports.setCredentials = setCredentials;
exports.setIsActive = setIsActive;
exports.setApiType = setApiType;
exports.empty = empty;
exports.decodeJsonField = decodeJsonField;
exports.decodeApiType = decodeApiType;
exports.fromJson = fromJson;
exports.encodeApiType = encodeApiType;
exports.toJson = toJson;
exports.decode = decode;
exports.decodeList = decodeList;
exports.statusText = statusText;
exports.statusClass = statusClass;
exports.availableMethods = availableMethods;
exports.availableApiType = availableApiType;
/* No side effect */
